export const collect = async (source, maxCount) => {
    if ((maxCount !== undefined) && (maxCount <= 0)) {
        return [];
    }
    const items = [];
    for await (const item of source) {
        items.push(item);
        if ((maxCount !== undefined) && (items.length >= maxCount)) {
            break;
        }
    }
    return items;
};
